import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, ShoppingCart, MapPin } from 'lucide-react';
const overOnsItems = [{
  label: 'Over De Maekerij',
  to: '/over-ons'
}, {
  label: 'Kernteam',
  to: '/team'
}, {
  label: 'Lesgevers',
  to: '/lesgevers'
}, {
  label: 'Vrijwilligers',
  to: '/vrijwilligers'
}, {
  label: 'Femma',
  to: '/femma'
}, {
  label: 'Verhalen',
  to: '/verhalen'
}];
const contactItems = [{
  label: 'Contactformulier',
  to: '/contact#contactformulier'
}, {
  label: 'Kernteam',
  to: '/team'
}, {
  label: 'Bereikbaarheid',
  to: '/contact#bereikbaarheid'
}];
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOverOnsOpen, setIsOverOnsOpen] = useState(false);
  const [isMobileOverOnsOpen, setIsMobileOverOnsOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isMobileContactOpen, setIsMobileContactOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const contactDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOverOnsOpen(false);
      }
      if (contactDropdownRef.current && !contactDropdownRef.current.contains(event.target as Node)) {
        setIsContactOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <>
      {/* Top Utility Bar */}
      <div className="bg-gray-100 border-b border-gray-200 py-1.5 hidden md:block relative z-[60]" data-id="element-178">
        <div className="container mx-auto px-4 flex justify-between items-center text-xs text-gray-600 font-medium" data-id="element-179">
          <span className="inline-flex items-center" data-id="element-180">
            <MapPin size={12} className="mr-1" data-id="element-181" />
            Louis Melsensstraat 17, 3000 Leuven
          </span>
          <div className="flex items-center space-x-6" data-id="element-182">
            <Link to="/faq" className="hover:text-gray-900 hover:underline" data-id="element-183">
              FAQ
            </Link>
            <Link to="/cadeaubonnen" className="hover:text-gray-900 hover:underline" data-id="element-184">
              Cadeaubonnen
            </Link>
            <Link to="/contact" className="hover:text-gray-900 hover:underline" data-id="element-185">
              Contact
            </Link>
            <button className="hover:text-gray-900 transition-colors duration-150" aria-label="Shopping cart" data-id="element-186">
              <ShoppingCart size={16} data-id="element-187" />
            </button>
          </div>
        </div>
      </div>

      <header className="border-b border-gray-300 bg-white sticky top-0 z-50" data-id="element-188">
        <div className="container mx-auto px-4 py-4" data-id="element-189">
          <div className="flex justify-between items-center" data-id="element-190">
            <Link to="/" className="text-2xl font-bold border-2 border-dashed border-gray-400 px-4 py-2" data-id="element-191">
              De Maekerij
            </Link>

            {/* Mobile menu button */}
            <div className="flex items-center space-x-2 md:hidden" data-id="element-192">
              <button className="border border-gray-300 p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300" aria-label="Shopping cart" data-id="element-193">
                <ShoppingCart size={20} data-id="element-194" />
              </button>
              <button className="border border-gray-300 p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={isMenuOpen} data-id="element-195">
                {isMenuOpen ? <X size={24} data-id="element-196" /> : <Menu size={24} data-id="element-197" />}
              </button>
            </div>

            {/* Desktop navigation */}
            <nav className="hidden md:flex space-x-6 items-center" data-id="element-198">
              {[{
              label: 'Maekerscafés',
              to: '/maekerscafés'
            }, {
              label: 'Workshops',
              to: '/workshop-info'
            }, {
              label: 'Kalender',
              to: '/workshops'
            }, {
              label: 'Koffiebar',
              to: '/koffiebar'
            }, {
              label: 'Zaalverhuur',
              to: '/locatie-huren'
            }].map(item => <Link key={item.label} to={item.to} className="hover:bg-gray-100 px-3 py-2 rounded transition-colors duration-150 font-medium text-gray-800" data-id="element-199">
                  {item.label}
                </Link>)}

              {/* Over ons dropdown */}
              <div className="relative" ref={dropdownRef} data-id="element-200">
                <button onClick={() => setIsOverOnsOpen(!isOverOnsOpen)} className="hover:bg-gray-100 px-3 py-2 rounded transition-colors duration-150 font-medium text-gray-800 inline-flex items-center focus:outline-none" data-id="element-201">
                  Over ons
                  <ChevronDown size={14} className={`ml-1 transition-transform duration-200 ${isOverOnsOpen ? 'rotate-180' : ''}`} data-id="element-202" />
                </button>
                {isOverOnsOpen && <div className="absolute right-0 top-full mt-1 w-52 bg-white border border-gray-200 rounded-lg shadow-sm py-1 z-50" data-id="element-203">
                    {overOnsItems.map(item => <Link key={item.to} to={item.to} className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150" onClick={() => setIsOverOnsOpen(false)} data-id="element-204">
                        {item.label}
                      </Link>)}
                  </div>}
              </div>
            </nav>
          </div>

          {/* Mobile navigation */}
          {isMenuOpen && <nav className="md:hidden pt-4 pb-2 border-t border-gray-200 mt-4" data-id="element-205">
              <ul className="space-y-2" data-id="element-206">
                {[{
              label: 'Maekerscafés',
              to: '/maekerscafés'
            }, {
              label: 'Workshops',
              to: '/workshop-info'
            }, {
              label: 'Kalender',
              to: '/workshops'
            }, {
              label: 'Koffiebar',
              to: '/koffiebar'
            }, {
              label: 'Zaalverhuur',
              to: '/locatie-huren'
            }].map(item => <li key={item.label} data-id="element-207">
                    <Link to={item.to} className="block hover:bg-gray-100 px-3 py-2 rounded transition-colors duration-150 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-208">
                      {item.label}
                    </Link>
                  </li>)}

                {/* Over ons with sub-items */}
                <li data-id="element-209">
                  <button onClick={() => setIsMobileOverOnsOpen(!isMobileOverOnsOpen)} className="w-full flex justify-between items-center hover:bg-gray-100 px-3 py-2 rounded transition-colors duration-150 font-medium text-left" data-id="element-210">
                    Over ons
                    <ChevronDown size={14} className={`text-gray-400 transition-transform duration-200 ${isMobileOverOnsOpen ? 'rotate-180' : ''}`} data-id="element-211" />
                  </button>
                  {isMobileOverOnsOpen && <ul className="ml-4 mt-1 space-y-1" data-id="element-212">
                      {overOnsItems.map(item => <li key={item.to} data-id="element-213">
                          <Link to={item.to} className="block hover:bg-gray-100 px-3 py-2 rounded text-sm text-gray-600" onClick={() => {
                    setIsMenuOpen(false);
                    setIsMobileOverOnsOpen(false);
                  }} data-id="element-214">
                            {item.label}
                          </Link>
                        </li>)}
                    </ul>}
                </li>

                {/* Mobile utility links */}
                <li className="pt-2 mt-2 border-t border-gray-100" data-id="element-215"></li>
                <li data-id="element-216">
                  <Link to="/faq" className="block hover:bg-gray-100 px-3 py-2 rounded text-sm text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-217">
                    FAQ
                  </Link>
                </li>
                <li data-id="element-218">
                  <Link to="/cadeaubonnen" className="block hover:bg-gray-100 px-3 py-2 rounded text-sm text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-219">
                    Cadeaubonnen
                  </Link>
                </li>
                <li data-id="element-220">
                  <Link to="/contact" className="block hover:bg-gray-100 px-3 py-2 rounded text-sm text-gray-600" onClick={() => setIsMenuOpen(false)} data-id="element-221">
                    Contact
                  </Link>
                </li>
              </ul>
            </nav>}
        </div>
      </header>
    </>;
}